export default __webpack_public_path__ + "static/media/desing-for-change.eba49c68.png";